import {QueryAccountByIds} from "@/components/selectAccountCtl/servers/userSelServer";
import {GoingNewUtils} from "xmgoing-utils";

export class AccountFactory {
  accountIdsAry: any;
  accountLoading: boolean;
  addAccountMapQueue: any;
  accountLabelMap:any;

  constructor() {
    this.accountIdsAry = [];
    this.addAccountMapQueue = {};
    this.accountLoading = false;
    this.accountLabelMap={};
  }


  /**
   * 角色id 翻译成中文 的处理
   */
  addAccountIds(ids) {
    if (typeof (ids) === 'string') {
      ids = ids.split(",");
    }
    if(Array.isArray(ids)){
      this.accountIdsAry = [...this.accountIdsAry, ...ids];
    }
  }

  /**
   * 获取所有角色信息
   */
  loadingAllAccounts() {
    this.accountLoading = true;
    this.accountIdsAry = [...new Set(this.accountIdsAry)];
    if(this.accountIdsAry.length>0){
      QueryAccountByIds({ids: this.accountIdsAry.join(";")}, (res) => {
        this.accountIdsAry=[];
        this.accountLoading=false;
        //设置accountMap
        if(res&&res.records){
          res.records.forEach((accountObj)=>{
            this.accountLabelMap[accountObj.id]=accountObj;
          })
        }
        Object.keys(this.addAccountMapQueue).forEach((propIds)=>{
          const flushMapFlag=this.addAccountMapQueue[propIds];
          flushMapFlag.value=GoingNewUtils.getUUChar(32);
        })

      })
    }
  }

  getAccountLabelById(userId){
    return this.accountLabelMap[userId]
  }

  /**
   * 获取角色映射信息
   * @param ids
   * @param selAccountRecords
   */
  getAccountLabels(ids, selAccountRecords) {
    this.addAccountMapQueue[GoingNewUtils.getUUChar(32)]=selAccountRecords;
    if(this.accountIdsAry.length>0&&this.accountLoading===false){
      this.loadingAllAccounts();
    }
  }
}
